import { connect } from 'react-redux';
import compose from 'recompose/compose';

import {
  getNextAvailableTimeIsFetching,
} from '../../main/barbers/selector';
import withTimezone from '../../auth/utils/withTimezone';
import { fetchNextAvailableTime } from '../../main/barbers/actions';

export default compose(
  withTimezone,
  connect(
    (state, ownProps) => ({
      isFetching: getNextAvailableTimeIsFetching(ownProps.barberId, ownProps.duration)(state),
    }),
    { fetchNextAvailableTime },
  )
);
